import React, { ChangeEvent } from 'react';
import { isNull, isUndefined } from 'util';

interface Props {
    name: string;
    value: boolean | null | undefined;
    hint?: string;
    empty?: string;
    onChange: (value: boolean | null | undefined, name: string) => void;
}

interface State {
    value: string;
}

class BoolSelect extends React.Component<Props, State> {

    public state = {
        value: '',
    };

    private getStringValue(value: boolean | null | undefined) {
        if (isNull(value) || isUndefined(value)) {
            return '';
        }
        return value ? 'true' : 'false';
    }

    private getBooleanValue() {
        if (this.state.value === '') {
            return null;
        }

        if (this.state.value === 'true') {
            return true;
        }

        if (this.state.value === 'false') {
            return false;
        }

        return undefined;
    }

    public componentDidMount() {
        this.setState({value: this.getStringValue(this.props.value)});
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: this.getStringValue(props.value)});
    }

    public render() {
        return (
            <>
                <select
                    className="form-control"
                    value={this.state.value}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                        this.setState({value: e.currentTarget.value}, () => {
                            this.props.onChange(this.getBooleanValue(), this.props.name);
                        });
                    }}
                >
                    <option value="">{this.props.empty || 'Összes'}</option>
                    <option value="true">Igen</option>
                    <option value="false">Nem</option>
                </select>
                {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
            </>
        );
    }
}

export default BoolSelect;



// WEBPACK FOOTER //
// ./src/components/Form/BoolSelect.tsx